import {Tooltip as GWCTooltip, TooltipProps} from '@gwc/core'

export type {TooltipProps}

export function Tooltip(props: TooltipProps) {
  return props.disabled ? props.children : <GWCTooltip delay={0} {...props} />
}
